<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '@/iam/external/types';
import { Auth } from '@/type';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './account-repository';

interface Data {
  task: Promise<Account[]>|null,
}

export default defineComponent({
  emits: ['loaded'],
  components: {
    Loader,
  },
  props: {
    platform: {
      type: String,
      required: true,
    },
    auth: {
      type: Object as () => Auth,
      required: true,
    },
    credentials: {
      type: Object,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    load(): void {
      this.task = repository.findAll(this.platform, this.auth, this.credentials);
      this.task.then((accounts: Account[]) => {
        this.$emit('loaded', accounts);
      });
    },
  },
  created(): void {
    this.load();
  },
});
</script>
